module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/manage/reset-password/reset-password.component.css
// module id = ./src/app/components/manage/reset-password/reset-password.component.css
// module chunks = main